import React from 'react'

interface Props {
    value: number
    class: string
    defaultValue: string
    useUnitClass: boolean
}

export class LargeNumber extends React.Component<Props> {
    public static defaultProps = {
        value: 0,
        class: 'requests',
        defaultValue: '-',
        useUnitClass: true,
    }

    public leftPad = (input, length, character) => {
        return Array(length - String(input).length + 1).join(character || '0') + input
    }

    public getDecimals = value => {
        let decimals = 0

        // We could use Math.log to determine this, but I guess this is more
        // readable…
        if (value < 10) {
            decimals = 2
        } else if (value < 100) {
            decimals = 1
        }

        return decimals
    }

    public render() {
        let { value } = this.props
        const { class: givenClass, useUnitClass, defaultValue } = this.props
        const className = useUnitClass ? 'unit ' + givenClass : givenClass

        if (!value) {
            return <span className={className}>{defaultValue}</span>
        }

        if (value < 1000) {
            return <span className={className}>{value.toFixed(0)}</span>
        }

        if (value < 100000) {
            return (
                <span className={className}>
                    {Math.floor(value / 1000)} {this.leftPad(Math.floor(value % 1000), 3, '0')}
                </span>
            )
        }

        // See: https://english.stackexchange.com/questions/112248/numeric-abbreviations-in-business-quotes
        const factors = [1000, 1000, 1000, 1000, 1000]
        const sizes = ['', 'k', 'M', 'B', 'T']
        let type = 0

        while (factors[type] && value > factors[type]) {
            value /= factors[type]
            type++
        }

        return (
            <span className={className}>
                {value.toFixed(this.getDecimals(value))}
                {sizes[type]}
            </span>
        )
    }
}

export default LargeNumber
